module.exports = __webpack_public_path__ + "media/images/frontend/download_covid19_file-c94ce036c35649781c847fdec21e9acc.png";